"use strict";
(self["webpackChunkshine_on"] = self["webpackChunkshine_on"] || []).push([[919],{

/***/ 4552:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {


// EXTERNAL MODULE: ./node_modules/vue/dist/vue.min.js
var vue_min = __webpack_require__(9346);
var vue_min_default = /*#__PURE__*/__webpack_require__.n(vue_min);
;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib/index.js??vue-loader-options!./src/scripts/vue/templates/Brands.vue?vue&type=template&id=cab55d6c&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.letters)?_c('div',{staticClass:"brands wrapper-lg"},[_c('div',{staticClass:"brands-count"},[_c('small',[_vm._v("Stocking "+_vm._s(_vm.brandsCount)+" brands")])]),_vm._v(" "),_c('ul',{staticClass:"brands__letters"},_vm._l((_vm.letters),function(brands,letter){return (!_vm.hiddenLetters.includes(letter))?_c('li',{key:letter,staticClass:"brands__letters--letter"},[_c('ul',[_c('li',{staticClass:"brands__letter-header"},[_c('strong',{staticClass:"h1",domProps:{"textContent":_vm._s(/\d/.test(letter[0]) ? '0-9' : letter)}})]),_vm._v(" "),_vm._l((brands),function(brand){return _c('li',{key:brand.id},[(brand.in_store)?_c('a',{staticClass:"brands__letter-brandlink",attrs:{"href":("/collections/" + (brand.handle)),"title":brand.title,"aria-label":brand.title},domProps:{"textContent":_vm._s(brand.title)}}):_vm._e()])})],2)]):_vm._e()}),0)]):_c('div',{staticClass:"brands__letters--loading"},[_c('Loading',{attrs:{"activated":true}})],1)}
var staticRenderFns = []


// EXTERNAL MODULE: ./src/scripts/vue/components/Loading.vue + 4 modules
var Loading = __webpack_require__(9918);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js!./node_modules/vue-loader/lib/index.js??vue-loader-options!./src/scripts/vue/templates/Brands.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var Brandsvue_type_script_lang_js_ = ({
  name: 'Brands',
  components: {
    Loading: Loading/* default */.Z
  },

  data() {
    return {
      letters: {
        '0-9': []
      },
      hiddenLetters: [],
      brandsCount: 0
    };
  },

  created() {
    fetch('/collections/all?view=brands-metafields').then(res => res.json()).then(data => {
      for (const letter in data.letters) {
        if (data.letters[letter]) {
          let letterHasEntries = false;

          if (/\d/.test(letter[0])) {
            this.letters['0-9'] = [...this.letters['0-9'], ...data.letters[letter]];
          } else {
            this.letters[letter] = data.letters[letter];
          }

          data.letters[letter].forEach(entry => {
            if (entry.in_store) {
              letterHasEntries = true;
              this.brandsCount++;
            }
          });

          if (!letterHasEntries) {
            this.hiddenLetters.push(letter);
          }
        }
      }
    });
  }

});
;// CONCATENATED MODULE: ./src/scripts/vue/templates/Brands.vue?vue&type=script&lang=js&
 /* harmony default export */ var templates_Brandsvue_type_script_lang_js_ = (Brandsvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1900);
;// CONCATENATED MODULE: ./src/scripts/vue/templates/Brands.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.Z)(
  templates_Brandsvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Brands = (component.exports);
;// CONCATENATED MODULE: ./src/scripts/templates/page.brands.js



window.PSTheme.Vue.Brands = new (vue_min_default())({
  name: 'Brands',
  components: {
    Brands: Brands
  }
}).$mount('.brands');

/***/ }),

/***/ 9918:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Loading; }
});

;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib/index.js??vue-loader-options!./src/scripts/vue/components/Loading.vue?vue&type=template&id=b5c84ec2&functional=true&
var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{class:[ 'site-loading', { 'activated': _vm.props.activated }],staticStyle:{"z-index":"100"}},[_vm._m(0)])}
var staticRenderFns = [function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"spinner"},[_c('div',{staticClass:"circle one"}),_vm._v(" "),_c('div',{staticClass:"circle two"})])}]


;// CONCATENATED MODULE: ./src/scripts/vue/components/Loading.vue?vue&type=template&id=b5c84ec2&functional=true&

;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js!./node_modules/vue-loader/lib/index.js??vue-loader-options!./src/scripts/vue/components/Loading.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ var Loadingvue_type_script_lang_js_ = ({
  name: 'Loading',
  props: ['activated']
});
;// CONCATENATED MODULE: ./src/scripts/vue/components/Loading.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_Loadingvue_type_script_lang_js_ = (Loadingvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1900);
;// CONCATENATED MODULE: ./src/scripts/vue/components/Loading.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.Z)(
  components_Loadingvue_type_script_lang_js_,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

/* harmony default export */ var Loading = (component.exports);

/***/ }),

/***/ 1900:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ normalizeComponent; }
/* harmony export */ });
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function normalizeComponent (
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier, /* server only */
  shadowMode /* vue-cli only */
) {
  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = 'data-v-' + scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () {
        injectStyles.call(
          this,
          (options.functional ? this.parent : this).$root.$options.shadowRoot
        )
      }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functional component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [346], function() { return __webpack_exec__(4552); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ }
]);